import React from 'react';
import { connect } from 'react-redux';
import { checkPermission } from '../guards/can';
import PerformanceBar from './performance-bar/performance-bar';
import ExpandMore from './expand-more';
import './my-incentive-performance.css';

class IncentivePerformance extends React.Component {
    pointsPerPackIsVisible = (incentive) => {
      const { current_user } = this.props;
      if (incentive.kind === 'fixed_target'){
        return false;
      }
      if (current_user.attributes['user-group'] !== 'staff') {
        return true;
      }
      return checkPermission('view', 'objective_performance');
    }

    incentiveIsBaseTarget = (incentive) => {
      return incentive.kind === 'base_target';
    }

    hasReachedTarget(incentive) {
      return incentive.packs_sold >= incentive.target
    }

    pointsPerPack(incentive) {
      if (this.hasReachedTarget(incentive)) {
        return incentive.points_after_target;
      }
      if (this.incentiveIsBaseTarget(incentive) && incentive.packs_sold >= incentive.base_target) {
        return incentive.points_to_target_2;
      }
      return incentive.points_to_target;
    }
    render() {
    const { incentive, date, outlet_id, current_user, isStoreButtonHide } = this.props;
    
    return (
        <div className="my-incentives-performance">
            <div className="incentive-container">
                <div className="incentives-row">
                    <h4>{incentive.name}</h4>
                    <p className="incentives-correct-date">Correct as of {date}</p>
                </div>
                <div className="incentives-row">
                    <PerformanceBar incentive={incentive}/>
                </div>
                { incentive.reward_type !== 'prize' && this.pointsPerPackIsVisible(incentive) &&
                    <div className="incentives-row">
                        <p>Points per pack {this.pointsPerPack(incentive)}</p>
                    </div>
                }
                <ExpandMore
                  incentive={incentive}
                  outlet_id={outlet_id}
                  current_user={current_user}
                  points_per_pack_visible={this.pointsPerPackIsVisible(incentive)}
                  isStoreButtonHide={isStoreButtonHide}
                />
            </div>
        </div>
    )
    }
};

const mapStateToProps = (state) => {
  return {
    current_user: state.viewConfig.profile,
  };
};

export default connect(mapStateToProps)(IncentivePerformance);


// WEBPACK FOOTER //
// ./src/components/common/store-performances/incentive-performance.jsx